/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {
  isValidCanvas(state) {
    return state.canvas !== null && !!state.canvas.toJSON;
  },
  undos(state) {
    const stepsLen = state.steps ? state.steps.length : 0;
    if (stepsLen > 1 && state.currentStep > 0) {
      return state.steps.slice(1, state.currentStep + 1);
    }
    return [];
  },
  redos(state) {
    const stepsLen = state.steps ? state.steps.length : 0;
    if (stepsLen > 1 && state.currentStep < stepsLen - 1) {
      return state.steps.slice(state.currentStep + 1, stepsLen);
    }
    return [];
  },
  activeControls(state, getters) {
    return [...new Set(getters.undos.map(e => e.control))];
  },
  getFirstStep(state) {
    if (state.steps) {
      return state.steps[0];
    }
  },
  getCurrentUgcView(state) {
    return state.currentUgcView;
  }
};

export default getters;
